export const saQuotesData = [
  {
    "name": "Adelaide",
    "value": 3,
    "lat": -34.9281805,
    "lng": 138.5999312
  },
  {
    "name": "Albert Park",
    "value": 1,
    "lat": -34.8762326,
    "lng": 138.5214767
  },
  {
    "name": "Angle Vale",
    "value": 2,
    "lat": -34.6412198,
    "lng": 138.6461526
  },
  {
    "name": "Broadview",
    "value": 2,
    "lat": -34.8759436,
    "lng": 138.6150008
  },
  {
    "name": "Christie Downs",
    "value": 1,
    "lat": -35.1272875,
    "lng": 138.4969434
  },
  {
    "name": "Christies Beach",
    "value": 1,
    "lat": -35.1395801,
    "lng": 138.4697587
  },
  {
    "name": "Clovelly Park",
    "value": 1,
    "lat": -34.998473,
    "lng": 138.5708472
  },
  {
    "name": "Craigmore",
    "value": 1,
    "lat": -34.7006365,
    "lng": 138.7095493
  },
  {
    "name": "Cultana",
    "value": 3,
    "lat": -32.770861,
    "lng": 137.4954673870571
  },
  {
    "name": "Dry Creek",
    "value": 1,
    "lat": -34.8148068,
    "lng": 138.567052
  },
  {
    "name": "Edinburgh",
    "value": 2,
    "lat": -34.70880915,
    "lng": 138.62785207369055
  },
  {
    "name": "Elizabeth Vale",
    "value": 1,
    "lat": -34.7489643,
    "lng": 138.6676385
  },
  {
    "name": "Evanston South",
    "value": 1,
    "lat": -34.6205715,
    "lng": 138.7326159
  },
  {
    "name": "Gillman",
    "value": 1,
    "lat": -34.83573735,
    "lng": 138.53632974747904
  },
  {
    "name": "Glendambo",
    "value": 1,
    "lat": -30.9683773,
    "lng": 135.750209
  },
  {
    "name": "Hendon",
    "value": 1,
    "lat": -34.8744445,
    "lng": 138.5151719
  },
  {
    "name": "Hove",
    "value": 1,
    "lat": -35.0122882,
    "lng": 138.5237052
  },
  {
    "name": "Kapunda",
    "value": 1,
    "lat": -34.339951,
    "lng": 138.915863
  },
  {
    "name": "Loxton",
    "value": 1,
    "lat": -34.4511348,
    "lng": 140.5696644
  },
  {
    "name": "Mannum",
    "value": 1,
    "lat": -34.9134482,
    "lng": 139.3125775
  },
  {
    "name": "Maree",
    "value": 1,
    "lat": -17.002018200000002,
    "lng": 145.42362583543738
  },
  {
    "name": "Meningie",
    "value": 1,
    "lat": -35.6891286,
    "lng": 139.3364722
  },
  {
    "name": "Mile End",
    "value": 1,
    "lat": -34.9263377,
    "lng": 138.5711113
  },
  {
    "name": "Mount Barker",
    "value": 3,
    "lat": -35.0641302,
    "lng": 138.8586385
  },
  {
    "name": "Munno Para West",
    "value": 1,
    "lat": -34.6572412,
    "lng": 138.6697638
  },
  {
    "name": "Nairne",
    "value": 1,
    "lat": -35.0364036,
    "lng": 138.9095876
  },
  {
    "name": "Nuriootpa",
    "value": 1,
    "lat": -34.4693354,
    "lng": 138.9939006
  },
  {
    "name": "Old Calperum",
    "value": 2,
    "lat": -34.2189263,
    "lng": 140.67845527380695
  },
  {
    "name": "Port Adelaide",
    "value": 1,
    "lat": -34.8342755,
    "lng": 138.5123548
  },
  {
    "name": "Regency Park",
    "value": 1,
    "lat": -34.8625388,
    "lng": 138.5723971
  },
  {
    "name": "Renmark",
    "value": 1,
    "lat": -34.1743516,
    "lng": 140.7468863
  },
  {
    "name": "Renmark South",
    "value": 3,
    "lat": -34.1743516,
    "lng": 140.7468863
  },
  {
    "name": "Rhynie",
    "value": 1,
    "lat": -34.1445792,
    "lng": 138.6882751
  },
  {
    "name": "Salisbury South",
    "value": 1,
    "lat": -34.7640516,
    "lng": 138.6418765
  },
  {
    "name": "Smithfield Plains",
    "value": 2,
    "lat": -34.676735,
    "lng": 138.676858
  },
  {
    "name": "Wallaroo",
    "value": 1,
    "lat": -33.9308118,
    "lng": 137.6272608
  },
  {
    "name": "West Lakes",
    "value": 1,
    "lat": -34.8759925,
    "lng": 138.4982893
  }
];
